import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
@Component({})
export default class Refund extends Vue {
  async sleep(fun: Function) {
    // 异步执行完成才往后执行
    // eslint-disable-next-line no-promise-executor-return
    return new Promise(resolve =>
      // eslint-disable-next-line no-promise-executor-return
      setTimeout(() => {
        fun();
        resolve({});
      }, 1000)
    );
  }
  get refundCourseText() {
    return (refundCourse: any) => {
      return `${refundCourse?.app_name || ''}第${refundCourse?.progress
        ?.finish_num || 0}-${refundCourse?.progress?.total_num || 0}关`;
    };
  }
  isInteger(num: number) {
    if (!isNaN(num) && num % 1 === 0) {
      return true;
    } else {
      return false;
    }
  }
  transformMoney(val: number) {
    const money: number = val / 100;
    if (!this.isInteger(money)) {
      return money.toFixed(2);
    }

    return money.toFixed() + '.00';
  }
  getLocationParams() {
    const { origin, order_id, production_id, app_type } = this.$route.query;
    return {
      origin: Number(origin),
      order_id: Number(order_id),
      production_id: Number(production_id),
      app_type,
    };
  }
  postRefundCancel(orderId: number) {
    const params = {
      order_id: orderId,
    };
    return window.apis.postRefundCancel(params);
  }
  handleBackHome() {
    this.$router.push({
      name: 'refundManage',
      params: {},
    });
  }
}
